module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/togenkyo-ec74782ce11dec46ef76ff78b12269d7.png";